import { ComponentProps, useContext } from "react";
import { useSelector } from "react-redux";
import AppGlobalsContext from "app/AppGlobalsContext";
import { Breadcrumbs } from "app/components/ui/Breadcrumb/Breadcrumbs";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import { unescapeHtml, stripAllTags } from "app/utils/html/html";

type BreadcrumbState = { brand?: { displayBreadcrumb?: boolean }; resolution?: string };

/** Renders the breadcrumb trail only when the brand enables it via Sanity (`brand.displayBreadcrumb`) and the device is not mobile. */
export const BreadcrumbsContainer = ({ items, ...props }: ComponentProps<typeof Breadcrumbs>) => {
	const displayBreadcrumb = useSelector(
		(state: BreadcrumbState) => state.brand?.displayBreadcrumb
	);
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;

	if (!displayBreadcrumb || isMobile) {
		return null;
	}

	const itemsWithCleanLabels = items.map(item => ({
		...item,
		label: unescapeHtml(stripAllTags(item.label)),
	}));

	return <Breadcrumbs items={itemsWithCleanLabels} {...props} />;
};

BreadcrumbsContainer.displayName = "BreadcrumbsContainer";
